// Generated from the TokenTax Icons Figma Final page. Do not edit.
import * as React from 'react';
import type { IconProps } from './types';
import { Ref, forwardRef } from 'react';
const Info = ({ size, ...props }: IconProps, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ?? 18}
    height={size ?? 18}
    fill="none"
    viewBox="0 0 18 18"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      d="M9 2a7 7 0 1 1 0 14A7 7 0 0 1 9 2m0 1a6 6 0 1 0 0 12A6 6 0 0 0 9 3m.493 4.247v5.313h-.872V7.247zm.053-1.197h-.977V5h.977z"
    />
  </svg>
);
const ForwardRef = forwardRef(Info);
export default ForwardRef;
